import { render, staticRenderFns } from "./mrecruit.vue?vue&type=template&id=48cb8d34"
import script from "./mrecruit.vue?vue&type=script&lang=js"
export * from "./mrecruit.vue?vue&type=script&lang=js"
import style0 from "./mrecruit.vue?vue&type=style&index=0&id=48cb8d34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports